import React, { useEffect, useState } from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import Status from '../../../../UI/status/Status'
import { getDateAndTimeText } from '../../../../../helpers/date/dateHelper'
import { personTypes } from '../../../../../helpers/type/TypeHelper'

const SupplierAbout = ({ supplier }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplier])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Номер',
            value: supplier ? supplier.id : '-'
        })
        // listTemp.push({
        //     name: 'Статус',
        //     // value: supplyOrder && supplyOrder.status ? supplyOrder.status : '-'
        //     value: <Status status={supplier.status} />
        // })
        listTemp.push({
            name: 'Тип',
            value: supplier ? personTypes[supplier.type] : '-'
        })
        listTemp.push({
            name: 'Назва',
            value: supplier ? supplier.name : '-'
        })
        listTemp.push({
            name: 'ЄДРПОУ (ІПН)',
            value: supplier ? supplier.edrpou : '-'
        })
        listTemp.push({
            name: 'Дата створення',
            value: supplier ? getDateAndTimeText(supplier.createdAt) : '-'
        })
        listTemp.push({
            name: 'Синхронізовано з BAS?',
            value: supplier.basId ? 'Так' : 'Ні'
        })
        // listTemp.push({
        //     name: 'Опис',
        //     value: supplier ? supplier.description : '-'
        // })
        // listTemp.push({
        //     name: 'Підрозділ',
        //     value: department ? departmentText[department.type] + ' - ' + department.department.name : '-'
        // })
        // listTemp.push({
        //     name: 'Виконавець',
        //     value: user ? getUserName({ user: client }) : '-'
        // })

        setList(listTemp)
    }

  return (
    <MyListBlock
        className={'supplyOrderView__topBlock'}
        text={'Про постачальника'}
        list={list}
    />
  )
}

export default SupplierAbout